import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router";

function Header({ title }) {
    const history = useNavigate();
  return (
    <div className=" w-full bg-dbase h-16">
      <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
        <button onClick={() => history(-1)}>
          <FaArrowLeft />
        </button>
        <h2 className=" text-xl my-auto">{title}</h2>
      </div>
    </div>
  );
}

export default Header;
